import { render } from "./ContactNumberForm.vue?vue&type=template&id=4fd4770c&scoped=true&ts=true"
import script from "./ContactNumberForm.vue?vue&type=script&lang=ts"
export * from "./ContactNumberForm.vue?vue&type=script&lang=ts"

import "./ContactNumberForm.vue?vue&type=style&index=0&id=4fd4770c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd4770c"]])

export default __exports__